/* eslint-disable no-mixed-spaces-and-tabs */
/* eslint-disable react/jsx-wrap-multilines */
import React, { useEffect } from 'react';
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import { reset, submit } from 'redux-form';
import { useHistory, useLocation } from 'react-router';
import PropTypes from 'prop-types';
import { useInjectSaga } from '../../utils/injectSaga';
import saga from './saga';
import { useInjectReducer } from '../../utils/injectReducer';
import reducer from './reducer';
import { ModalWindow } from '../../semantic-ui/components/modal-window';
import ModalFooterButtons from '../../semantic-ui/components/modal-window/modal-footer-buttons';
import {
	getIcepackFillerInfoAction,
	createIcepackFillerAction,
	updateIcepackFillerAction,
	deleteIcepackFillerAction,
	resetStateAction,
} from './actions';
import {
	getIsModalShownSelector,
	getIsAuditTabShownSelector,
	getActiveIcepackFillerIdSelector,
	getIsIcepackFillerInfoLoadingSelector,
	getIcepackFillerInfoSelector,
	getIcepackFillerNameSelector,
	getIsIcepackFillerAddFormOpenSelector,
	getIsIcepackFillerCreatingSelector,
	getIsIcepackFillerEditFormOpenSelector,
	getIsIcepackFillerUpdatingSelector,
	getIsIcepackFillerDeletingSelector,
} from './selectors';
import { ICEPACK_FILLER_FORM_NAME } from './constants';
import { IcepackFillerModalContent } from './components/icepack-filler-modal-content';
import { setWindowInfoAction } from '../alert-modal/actions';
import { Audit } from '../../components/audit';
import { getIsAvailableIcepacksFillersButtonsSelector } from '../profile/selectors';
import closeModal from '../../utils/closeModal';
import { removeModalQuery } from '../../utils/removeModalQuery';

const IcepackFillerModalWrapper = ({
	isAvailable,
	isModalShown,
	isAuditTabShown,
	onFormSubmit,
	onClearForm,
	onResetState,
	activeIcepackFillerId,
	onGetIcepackFillerInfo,
	isIcepackFillerInfoLoading,
	icepackFillerInfo,
	icepackFillerName,
	isIcepackFillerAddFormOpen,
	onCreateIcepackFiller,
	isIcepackFillerCreating,
	isIcepackFillerEditFormOpen,
	onUpdateIcepackFiller,
	isIcepackFillerUpdating,
	onDeleteIcepackFiller,
	isIcepackFillerDeleting,
	onSetWindowInfo,
}) => {
	if (!isModalShown) return null;
	useInjectSaga({ key: 'icepackFillerModalSaga', saga });
	useInjectReducer({ key: 'icepackFillerModalReducer', reducer });

	const { search, pathname } = useLocation();

	const query = new URLSearchParams(search);

	const modal = query.get('modal');

	const mode = query.get('mode');

	const history = useHistory();

	useEffect(() => {
		if (activeIcepackFillerId) {
			onGetIcepackFillerInfo(activeIcepackFillerId);
		}
	}, [activeIcepackFillerId]);

	const handleNavItemClick = modal => {
		if (modal === 'audit') {
			query.set('tab', 'audit');
		} else {
			query.set('modal', modal);
			query.delete('tab');
		}

		if (mode) {
			query.delete('mode');
		}

		history.push(`${pathname}?${query}`);
	};

	const handleModalClose = () => {
		closeModal(query);

		onClearForm();
		onResetState();

		history.push(`${pathname}?${query}`);
	};

	const handleIcepackFillerFormOpenButtonClick = mode => {
		if (activeIcepackFillerId) {
			query.set('id', activeIcepackFillerId);
		} else {
			query.delete('id');
		}

		if (mode === 'edit') {
			query.set('mode', 'edit');
		}

		if (mode === 'cancel') {
			onClearForm();
			query.delete('mode');
		}

		if (mode === 'cancel' && !activeIcepackFillerId) {
			onResetState();
			query.delete('modal');
		}

		history.push(`${pathname}?${query}`);
	};

	const handleIcepackFillerFormSubmit = async () => {
		await onFormSubmit(ICEPACK_FILLER_FORM_NAME);

		if (activeIcepackFillerId) {
			onUpdateIcepackFiller({
				id: activeIcepackFillerId,
				searchQuery: removeModalQuery(query.toString()),
				redirect: () => handleIcepackFillerFormOpenButtonClick('cancel'),
			});

			return;
		}

		onCreateIcepackFiller({
			redirect: handleModalClose,
			searchQuery: removeModalQuery(query.toString()),
		});
	};

	const handleKeyDown = e => {
		if (e.key === 'Enter' && e.shiftKey === false) {
			handleIcepackFillerFormSubmit();
		}
	};

	const handleIcepackFillerDelete = () => {
		onSetWindowInfo({
			type: 'delete',
			title: 'Вы уверены?',
			text: 'Вы не сможете это отменить',
			button: {
				type: 'success',
				text: 'Да, удалить',
				onClick: () =>
					onDeleteIcepackFiller({
						id: activeIcepackFillerId,
						redirect: handleModalClose,
						searchQuery: removeModalQuery(query.toString()),
					}),
			},
		});
	};

	return (
		<ModalWindow
			isLoading={isIcepackFillerInfoLoading}
			isModalShown={isModalShown}
			onKeyDown={handleKeyDown}
			onClose={handleModalClose}
			navItems={
				isIcepackFillerEditFormOpen || isIcepackFillerAddFormOpen
					? []
					: [
							{
								id: 'info',
								text: 'Информация',
								onClick: () => handleNavItemClick('icepack_filler'),
								isActive: modal === 'icepack_filler' && !isAuditTabShown,
							},
							{
								id: 'audit',
								text: 'Изменения',
								onClick: () => handleNavItemClick('audit'),
								isActive: isAuditTabShown,
							},
					  ]
			}
			headerText={
				isIcepackFillerEditFormOpen || isIcepackFillerAddFormOpen
					? `${isIcepackFillerEditFormOpen ? 'Изменить наполнитель' : 'Создать наполнитель'}`
					: icepackFillerName
			}
			modalContent={
				!isAuditTabShown ? (
					<IcepackFillerModalContent
						isLoading={isIcepackFillerInfoLoading || isIcepackFillerDeleting}
						icepackFillerInfo={icepackFillerInfo}
						isIcepackFillerFormOpen={isIcepackFillerEditFormOpen || isIcepackFillerAddFormOpen}
					/>
				) : (
					<Audit entityName="icepacks_fillers" entityId={activeIcepackFillerId} />
				)
			}
			style={{ width: '895px' }}
			actionButtons={[{ type: 'close', onClick: handleModalClose, text: 'profile' }]}
			footerButtons={
				<ModalFooterButtons
					leftButtons={
						!(isIcepackFillerEditFormOpen || isIcepackFillerAddFormOpen) &&
						isAvailable.delete &&
						!isAuditTabShown
							? [
									{
										onClick: handleIcepackFillerDelete,
										text: 'Удалить',
										color: 'warning',
										disabled: isIcepackFillerInfoLoading || isIcepackFillerDeleting,
									},
							  ]
							: []
					}
					rightButtons={
						isIcepackFillerEditFormOpen || isIcepackFillerAddFormOpen
							? [
									{
										onClick: handleIcepackFillerFormSubmit,
										text: 'Сохранить',
										color: 'primary',
										loading: isIcepackFillerUpdating || isIcepackFillerCreating,
										disabled:
											isIcepackFillerInfoLoading ||
											isIcepackFillerUpdating ||
											isIcepackFillerCreating,
									},
									{
										onClick: () => handleIcepackFillerFormOpenButtonClick('cancel'),
										text: 'Отмена',
										color: 'secondary',
										disabled: isIcepackFillerUpdating || isIcepackFillerCreating,
									},
							  ]
							: [
									...(isAvailable.update && !isAuditTabShown
										? [
												{
													onClick: () => handleIcepackFillerFormOpenButtonClick('edit'),
													text: 'Изменить',
													color: 'primary',
													disabled: isIcepackFillerInfoLoading || isIcepackFillerDeleting,
												},
										  ]
										: []),
									{
										onClick: handleModalClose,
										text: 'Закрыть',
										color: 'secondary',
									},
							  ]
					}
				/>
			}
		/>
	);
};

const mapFillerToProps = createStructuredSelector({
	isAvailable: getIsAvailableIcepacksFillersButtonsSelector(),
	isModalShown: getIsModalShownSelector(),
	isAuditTabShown: getIsAuditTabShownSelector(),
	activeIcepackFillerId: getActiveIcepackFillerIdSelector(),
	isIcepackFillerInfoLoading: getIsIcepackFillerInfoLoadingSelector(),
	icepackFillerInfo: getIcepackFillerInfoSelector(),
	icepackFillerName: getIcepackFillerNameSelector(),
	isIcepackFillerAddFormOpen: getIsIcepackFillerAddFormOpenSelector(),
	isIcepackFillerCreating: getIsIcepackFillerCreatingSelector(),
	isIcepackFillerEditFormOpen: getIsIcepackFillerEditFormOpenSelector(),
	isIcepackFillerUpdating: getIsIcepackFillerUpdatingSelector(),
	isIcepackFillerDeleting: getIsIcepackFillerDeletingSelector(),
});

const mapDispatchToProps = {
	onFormSubmit: submit,
	onClearForm: () => reset(ICEPACK_FILLER_FORM_NAME),
	onResetState: resetStateAction,
	onGetIcepackFillerInfo: getIcepackFillerInfoAction,
	onCreateIcepackFiller: createIcepackFillerAction,
	onUpdateIcepackFiller: updateIcepackFillerAction,
	onDeleteIcepackFiller: deleteIcepackFillerAction,
	onSetWindowInfo: setWindowInfoAction,
};

const IcepackFillerModal = connect(mapFillerToProps, mapDispatchToProps)(IcepackFillerModalWrapper);

IcepackFillerModalWrapper.propTypes = {
	isAvailable: PropTypes.objectOf(PropTypes.bool),
	isModalShown: PropTypes.bool.isRequired,
	isAuditTabShown: PropTypes.bool.isRequired,
	onFormSubmit: PropTypes.func.isRequired,
	onClearForm: PropTypes.func.isRequired,
	onResetState: PropTypes.func.isRequired,
	activeIcepackFillerId: PropTypes.string,
	isIcepackFillerInfoLoading: PropTypes.bool.isRequired,
	onGetIcepackFillerInfo: PropTypes.func.isRequired,
	icepackFillerInfo: PropTypes.array,
	icepackFillerName: PropTypes.string.isRequired,
	isIcepackFillerAddFormOpen: PropTypes.bool.isRequired,
	onCreateIcepackFiller: PropTypes.func.isRequired,
	isIcepackFillerCreating: PropTypes.bool.isRequired,
	isIcepackFillerEditFormOpen: PropTypes.bool.isRequired,
	onUpdateIcepackFiller: PropTypes.func.isRequired,
	isIcepackFillerUpdating: PropTypes.bool.isRequired,
	onDeleteIcepackFiller: PropTypes.func.isRequired,
	isIcepackFillerDeleting: PropTypes.bool.isRequired,
	onSetWindowInfo: PropTypes.func.isRequired,
};

export default IcepackFillerModal;
